<ion-header>

  <ion-row class="barra-color-topo"></ion-row>

  <ion-grid class="grid-menu-topo">

    <!-- MOBILE -->

    <ion-row class="row-menu-topo ion-hide-md-up">

      <ion-menu-button class="col-menu-sanduiche ion-align-self-center">
        <ion-menu-toggle>
          <ion-img src="../../assets/icon/icone_menu_sanduiche.svg"></ion-img>
        </ion-menu-toggle>
      </ion-menu-button>

      <ion-col class="ion-align-self-center center-img">
        <ion-img class="img-logo-topo" src="../../assets/image/timemultipremiado_horizontal.png"></ion-img>
      </ion-col>

      <ion-col class="col-menu-perfil ion-align-self-center">
          <ion-img src="../../assets/image/carrinho_vazio.png" (click)="touchGoToRoute('/store/store-checkout')"></ion-img>
      </ion-col>

      <ion-menu-button class="col-menu-perfil ion-align-self-center" menu="end">
        <ion-menu-toggle menu="end">
          <ion-img [src]="modelLocator.menu.embaixador ? '../../assets/icon/icone_perfil_embaixador.svg' : '../../assets/icon/icone_perfil.svg'"></ion-img>
        </ion-menu-toggle>
      </ion-menu-button>

    </ion-row>

    <!-- DESKTOP -->

    <ion-row class="row-menu-topo ion-hide-sm-down">

      <ion-col size="auto" class="col-logo-desktop ion-align-self-center">
        <ion-img class="img-logo-topo" src="../../assets/image/timemultipremiado_horizontal.png"></ion-img>
      </ion-col>

      <ion-col class="links-menu ion-align-self-center ion-text-center">
        <a (click)="touchGoToRoute('/home')" *ngIf="modelLocator.menu.interacao">INTERAÇÃO</a>
        <a (click)="touchGoToRoute('/store')" *ngIf="modelLocator.menu.premiacao">LOJA</a>
        <!-- <a (click)="touchGoToRoute('/benefits')" *ngIf="modelLocator.menu.beneficios">BENEFÍCIOS</a> -->
<!--        <a (click)="touchGoToRoute('/multi-awards')" *ngIf="modelLocator.menu.multipremios">MULTIPRÊMIOS</a>-->
        <a (click)="touchGoToRoute('/challenges')" *ngIf="modelLocator.menu.planos">DESAFIOS</a>
        <a (click)="touchGoToRoute('/multiluck')" *ngIf="modelLocator.menu.multisorte">MULTISORTE</a>
        <a (click)="touchGoToRoute('/information')" *ngIf="modelLocator.menu.informacao">INFORMAÇÃO</a>
        <!-- <a (click)="touchGoToRoute('/faq')">FAQ</a> -->
        <a (click)="touchGoToRoute('/my-points')" *ngIf="modelLocator.menu.planos">TABELA DE PONTOS</a>
        <a (click)="touchGoToRoute('/ambassador')" *ngIf="modelLocator.menu.embaixador">EMBAIXADOR</a>
      </ion-col>

      <ion-col size="auto" class="ion-align-self-center">
        <ion-row class="box-sair ion-align-items-center">
          <img class="img-carrinho-topo" src="../../assets/image/carrinho_vazio.png" (click)="touchGoToRoute('/store/store-checkout')">
          <img class="img-sair-topo" src="../../assets/icon/icone_sair.svg" alt="Sair" (click)="logout()">
          <a class="txt-sair-topo" (click)="logout()">Sair</a>
        </ion-row>
      </ion-col>

    </ion-row>

  </ion-grid>

</ion-header>
